import React from "react";
import MetricTableRow from "MetricTableRow";
import Table from "react-bootstrap/Table";
import { startCase, camelCase, cloneDeep } from "lodash";
import jsDig from "utils/jsDig";
import { Switch, FormGroup, FormControlLabel } from "@material-ui/core";
import { Stack, Lock, Unlock } from "react-bootstrap-icons";

class MetricTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      table: props.table,
      date: moment(props.date),
      headerOrder: this.props.headerOrder,
      compactView: this.props.userDefaultView && this.props.userDefaultView == "compact_table_view" ? true : false,
      width: window.innerWidth,
      lockColumns: {},
      selectedPlatform: this.props.selectedPlatform
    };
  }
  componentDidUpdate(prevProps) {
    if (prevProps.table !== this.props.table) {
      this.setState({
        table: this.props.table,
      });
    }
  }


  updateWidth = () => {
    this.setState({ width: window.innerWidth });
  };
  updateLock = (lockMetric, metricName) => {
    this.setState(
      (prevState) => ({ lockColumns: { ...prevState.lockColumns, [lockMetric]: !prevState.lockColumns[lockMetric] } }),
      () => {
        this.setState((prevState) => ({
          headerOrder: Object.values(prevState.lockColumns).includes(true)
            ? prevState.headerOrder.sort(function (x, y) {
                let metricTitleX = _.startCase(_.camelCase(x));
                if (metricTitleX.includes("Roas")) {
                  metricTitleX = metricTitleX.slice(0, -4) + metricTitleX.slice(-4).toUpperCase();
                }
                if (metricTitleX.includes("Aov")) {
                  metricTitleX = metricTitleX.slice(0, -3) + metricTitleX.slice(-3).toUpperCase();
                }

                if (metricTitleX.includes("Cpa")) {
                  metricTitleX = metricTitleX.slice(0, -3) + metricTitleX.slice(-3).toUpperCase();
                }
                if (metricTitleX.includes("Cvr")) {
                  metricTitleX = "Conv. Rate";
                }
                if (metricTitleX === "Traffic") {
                  metricTitleX = "Organic Traffic";
                }
                let metricTitleY = _.startCase(_.camelCase(y));
                if (metricTitleY.includes("Roas")) {
                  metricTitleY = metricTitleY.slice(0, -4) + metricTitleY.slice(-4).toUpperCase();
                }
                if (metricTitleY.includes("Aov")) {
                  metricTitleY = metricTitleY.slice(0, -3) + metricTitleY.slice(-3).toUpperCase();
                }

                if (metricTitleY.includes("Cpa")) {
                  metricTitleY = metricTitleY.slice(0, -3) + metricTitleY.slice(-3).toUpperCase();
                }
                if (metricTitleY.includes("Cvr")) {
                  metricTitleY = "Conv. Rate";
                }
                if (metricTitleY === "Traffic") {
                  metricTitleY = "Organic Traffic";
                }
                return prevState.lockColumns[`${metricTitleX}`] ? -1 : prevState.lockColumns[`${metricTitleY}`] ? 1 : 0;
              })
            : cloneDeep(this.props.headerOrder),
        }));
      }
    );
  };
  componentDidMount() {
    window.addEventListener("resize", this.updateWidth);
    this.state.headerOrder.map((metricName, index) => {
      let metricTitle = _.startCase(_.camelCase(metricName));

      this.setState((prevState) => ({ lockColumns: { ...prevState.lockColumns, [metricTitle]: false } }));
    });
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWidth);
  }
  render() {
    if (!this.props.table) return <div>No Data To Display Yet!</div>;
    let months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    let mobileMonths = ["Jan.", "Feb.", "Mar.", "Apr.", "May", "Jun.", "Jul.", "Aug.", "Sep.", "Oct.", "Nov.", "Dec."];
    const headerClass = this.props.ppc ? "ppc-table-row-header" : " seo-table-row-header";
    const renderHeader = this.state.headerOrder.map((metricName, index) => {
      let metricTitle = _.startCase(_.camelCase(metricName));

      if (metricTitle.includes("Roas")) {
        metricTitle = metricTitle.slice(0, -4) + metricTitle.slice(-4).toUpperCase();
      }
      if (metricTitle.includes("Aov")) {
        metricTitle = metricTitle.slice(0, -3) + metricTitle.slice(-3).toUpperCase();
      }

      if (metricTitle.includes("Cpa")) {
        metricTitle = metricTitle.slice(0, -3) + metricTitle.slice(-3).toUpperCase();
      }
      if (metricTitle.includes("Cvr")) {
        metricTitle = "Conv. Rate";
      }
      if (metricTitle === "Traffic") {
        metricTitle = "Organic Traffic";
      }
      return (
        <React.Fragment key={metricName}>
          {this.state.lockColumns[`${metricTitle}`] == true ? (
            <>
              <th
                scope="col"
                className={` table-row-header ${headerClass} lockhead`}
                colSpan="3"
                key={index}
                style={{ left: `${110 + 290 * this.state.headerOrder.indexOf(metricName)}px` }}>
                <div className="d-flex justify-content-center">
                  <p style={{ padding: "10px" }}>{metricTitle}</p>
                  <button className="lock-btn" onClick={() => this.updateLock(metricTitle, metricName)} style={{ marginBlock: "auto" }}>
                    {this.state.lockColumns[`${metricTitle}`] ? <Lock /> : <Unlock />}
                  </button>
                </div>
              </th>
            </>
          ) : (
            <>
              <th scope="col" className={` table-row-header ${headerClass}`} colSpan="3" key={index}>
                <div className="d-flex justify-content-center">
                  <p style={{ padding: "10px" }}>{metricTitle}</p>
                  <button className="lock-btn" onClick={() => this.updateLock(metricTitle, metricName)} style={{ marginBlock: "auto" }}>
                    {this.state.lockColumns[`${metricTitle}`] ? <Lock /> : <Unlock />}
                  </button>
                </div>
              </th>
            </>
          )}
        </React.Fragment>
      );
    });

    return (
      <React.Fragment>
        <FormGroup style={{ display: "flex", flexDirection: "row", float: "right" }}>
          <Stack fill="#30439c" style={{ marginBlock: "auto" }} />
          <FormControlLabel
            labelPlacement="start"
            control={
              <Switch
                color="primary"
                checked={!this.state.compactView}
                onChange={() => {
                  this.setState({ compactView: !this.state.compactView });
                }}
              />
            }
            label="Full View"
          />
        </FormGroup>

        <div className={this.props.responsive ? "table-responsive table-scroll" : "table-scroll"}>
          <Table className={`mt-2 table-white table-striped ${this.state.compactView ? "metric-table-compact" : "metric-table-full"} metric-table`}>
            <thead>
              <tr>
                <th scope="col" colSpan="1" className="scroll-behind yy-table-header" style={{ border: "none" }}></th>
                {renderHeader}
              </tr>
              <tr className="dates bg-transparent">
                <th className="month-cell empty-space" style={{ border: "none", backgroundColor: "#E1E1E1" }}></th>
                {this.state.headerOrder.map((metricName) => {
                  let metricTitle = _.startCase(_.camelCase(metricName));
                  if (metricTitle.includes("Roas")) {
                    metricTitle = metricTitle.slice(0, -4) + metricTitle.slice(-4).toUpperCase();
                  }
                  if (metricTitle.includes("Aov")) {
                    metricTitle = metricTitle.slice(0, -3) + metricTitle.slice(-3).toUpperCase();
                  }

                  if (metricTitle.includes("Cpa")) {
                    metricTitle = metricTitle.slice(0, -3) + metricTitle.slice(-3).toUpperCase();
                  }
                  if (metricTitle.includes("Cvr")) {
                    metricTitle = "Conv. Rate";
                  }
                  if (metricTitle === "Traffic") {
                    metricTitle = "Organic Traffic";
                  }
                  return (
                    <React.Fragment key={metricName}>
                      {this.state.lockColumns[`${metricTitle}`] == true ? (
                        <>
                          <th
                            scope="col"
                            className="bg-white lock1"
                            style={{ border: "1px solid #e1e1e1 ", left: `${110 + 290 * this.state.headerOrder.indexOf(metricName)}px` }}>
                            {parseInt(this.props.date.substring(0, 4)) - 1}
                          </th>
                          <th
                            scope="col"
                            className="bg-white lock2"
                            style={{ border: "1px solid #e1e1e1 ", left: `${220 + 290 * this.state.headerOrder.indexOf(metricName)}px` }}>
                            {" "}
                            {this.state.date.year()}{" "}
                          </th>
                          <th
                            scope="col"
                            className="bg-white lock3"
                            style={{ border: "1px solid #e1e1e1 ", left: `${330 + 290 * this.state.headerOrder.indexOf(metricName)}px` }}>
                            Y/Y
                          </th>
                        </>
                      ) : (
                        <>
                          <th scope="col" className="bg-white subheader-year" style={{ border: "1px solid #e1e1e1 " }}>
                            {parseInt(this.props.date.substring(0, 4)) - 1}
                          </th>
                          <th scope="col" className="bg-white subheader-year" style={{ border: "1px solid #e1e1e1 " }}>
                            {" "}
                            {this.state.date.year()}{" "}
                          </th>
                          <th scope="col" className="bg-white subheader-yy" style={{ border: "1px solid #e1e1e1 " }}>
                            Y/Y
                          </th>
                        </>
                      )}
                    </React.Fragment>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((num) => {
                return (
                  <tr key={num}>
                    <th className={(num % 3 != 0 ? "no-border-tb" : "no-border-t") + " text-left month-cell"} scope="row">
                      <span className="metric-table-month">{this.state.width > 600 ? months[num - 1] : mobileMonths[num - 1]}</span>
                    </th>
                    {this.state.headerOrder.map((metricName) => {
                      return (
                        <MetricTableRow
                          key={metricName}
                          metricName={metricName}
                          client={this.props.client}
                          rowNumber={num}
                          thisYearValue={jsDig([metricName, this.state.date.year().toString(), num.toString()], this.state.table)}
                          lastYearValue={jsDig([metricName, (this.state.date.year() - 1).toString(), num.toString()], this.state.table)}
                          lockColumns={this.state.lockColumns}
                          indexOf={this.state.headerOrder.indexOf(metricName)}
                          baseCurrency={this.props.baseCurrency}
                          displayCurrency={this.props.displayCurrency}
                        />
                      );
                    })}
                  </tr>
                );
              })}
              <tr style={{ backgroundColor: "#e0e4ef" }} className="last-row">
                <th className="no-border-tb text-left first-cell" scope="row">
                  <span className="metric-table-month">YTD</span>
                </th>
                {this.state.headerOrder.map((metricName) => {
                  return (
                    <MetricTableRow
                      key={metricName}
                      client={this.props.client}
                      metricName={metricName}
                      rowNumber={13}
                      thisYearValue={jsDig([metricName, this.state.date.year().toString(), "ytd"], this.state.table)}
                      lastYearValue={jsDig([metricName, (this.state.date.year() - 1).toString(), "ytd"], this.state.table)}
                      lockColumns={this.state.lockColumns}
                      indexOf={this.state.headerOrder.indexOf(metricName)}
                      baseCurrency={this.props.baseCurrency}
                      displayCurrency={this.props.displayCurrency}
                    />
                  );
                })}
              </tr>
              <tr style={{ backgroundColor: "#e0e4ef" }} className="last-row">
                <th className="no-border-t text-left first-cell" scope="row">
                  <span className="metric-table-month">Total</span>
                </th>
                {this.state.headerOrder.map((metricName) => {
                  return (
                    <MetricTableRow
                      key={metricName}
                      metricName={metricName}
                      client={this.props.client}
                      rowNumber={14}
                      thisYearValue={jsDig([metricName, this.state.date.year().toString(), "total"], this.state.table)}
                      lastYearValue={jsDig([metricName, (this.state.date.year() - 1).toString(), "total"], this.state.table)}
                      bottomRow={true}
                      lockColumns={this.state.lockColumns}
                      indexOf={this.state.headerOrder.indexOf(metricName)}
                      baseCurrency={this.props.baseCurrency}
                      displayCurrency={this.props.displayCurrency}
                    />
                  );
                })}
              </tr>
            </tbody>
          </Table>
        </div>
      </React.Fragment>
    );
  }
}
export default MetricTable;
